<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'
import { ref } from 'vue'
import SaiTooltip from '@/components/common/SaiTooltip/index.ce.vue';
//ref
const showTooltip = ref(false);
const tooltipTarget = ref<HTMLElement | null>(null);
const tooltipText = ref('');

// emits
const emit = defineEmits(['handleDocAction']);

//props
interface Props {
  item: any,
  activeCollectionName: string
}
const props = withDefaults(defineProps<Props>(), {
  item: {},
  activeCollectionName: ''
})


//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

const handleDocAction = (action: string) => {
    emit('handleDocAction', {action, docId: props.item.doc_id});
}

const getTooltipText = (action: string) => {
    switch (action) {
        case 'watchItem':
            return t('watchItem', [props.activeCollectionName]);
        case 'unWatchItem':
        case 'unWatchItemGlobal':
            return t('unwatchItem', [props.activeCollectionName]);
        case 'addItem':
            return t('addItem', [props.activeCollectionName]);
        case 'remItem':
            return t('removeItem', [props.activeCollectionName]);
        default:
            return '';
    }
};

const handleActionEnter = (action: string, event: MouseEvent) => {
    tooltipTarget.value = event.currentTarget as HTMLElement;
    tooltipText.value = getTooltipText(action);
    showTooltip.value = !!tooltipText.value;
};

const handleActionLeave = () => {
    showTooltip.value = false;
};

const isActionAllowed = (action: string) => {
    const docActions = (typeof(props.item.actions) != "undefined")  ? props.item.actions : {};
    return docActions &&
        Object.prototype.hasOwnProperty.call(docActions, action) &&
        docActions[action];
};
const isActionsAvailable = () => {
    const docActions = (typeof(props.item.actions) != "undefined")  ? props.item.actions : {};
    if(docActions && Object.keys(docActions).length > 0) {
      return Object.values(docActions).some(value => value === true);
    }
    return false;
};

</script>

<template>
    <div class="doc-actions">
        <div v-if="isActionsAvailable()" class="doc-action-menu">
          <div v-if="isActionAllowed('watchItem')" class="doc-action-item watch" @click="handleDocAction('watchItem')" @mouseenter="handleActionEnter('watchItem', $event)" @mouseleave="handleActionLeave"></div>
          <div v-if="isActionAllowed('unWatchItem')" class="doc-action-item active watch" @mouseenter="handleActionEnter('unWatchItem', $event)" @mouseleave="handleActionLeave" @click="handleDocAction('unWatchItem')"></div>
          <div v-if="isActionAllowed('unWatchItemGlobal')" class="doc-action-item active watch" @mouseenter="handleActionEnter('unWatchItemGlobal', $event)" @mouseleave="handleActionLeave" @click="handleDocAction('unWatchItemGlobal')"></div>
          <div v-if="isActionAllowed('addItem')" class="doc-action-item add-to-collection" @mouseenter="handleActionEnter('addItem', $event)" @mouseleave="handleActionLeave" @click="handleDocAction('addItem')"></div>
          <div v-if="isActionAllowed('remItem')" class="doc-action-item active add-to-collection" @mouseenter="handleActionEnter('remItem', $event)" @mouseleave="handleActionLeave" @click="handleDocAction('remItem')"></div>
       </div>
       <SaiTooltip v-if="tooltipTarget" v-model="showTooltip" :target="tooltipTarget" placement="left-middle" :offset="8">
            {{ tooltipText }}
       </SaiTooltip>
    </div>
</template>
